module.exports = __webpack_public_path__ + "prize-more.47d14f0a.png";